import { Group, Stack, Text, Tooltip } from '@mantine/core';

import AnimatedNumber from '@/components/Dashboard/AnimatedNumber';
import { SvgInfo } from '@/components/Dashboard/icon';

interface TitleCardProps {
  title: string;
  value: number;
  valueColor?: string;
  desc: string;
  tip?: string;
}

const TitleCard: React.FC<TitleCardProps> = ({ desc, tip, title, value, valueColor }) => {
  return (
    <Stack className="bg-gray-50 p-4 rounded-lg shadow-sm" p={16} gap={12} miw={300}>
      <Group>
        <Tooltip label={tip} disabled={!tip}>
          <Group gap={'sm'}>
            <Text size={'sm'}>{title}</Text>
            {tip && <SvgInfo />}
          </Group>
        </Tooltip>
      </Group>
      <Group justify="space-between" className="items-center space-x-4">
        <Text className="text-xl" style={{ color: valueColor || '#000' }}>
          <AnimatedNumber targetValue={value} />
        </Text>
        <Text className="text-xs text-gray-400">{desc}</Text>
      </Group>
    </Stack>
  );
};

export default TitleCard;
